import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export function useProducts(brand) {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const url = brand ? `/products?brand=${brand}` : "/products";
    api.get(url).then((r) => setProducts(r.data)).finally(() => setLoading(false));
  }, [brand]);
  return { products, loading };
}
